/**
 * Common editor restrictions used across TipTap editors in the application
 */

export const restrictedEditorExtensions = [
  "file",
  "image",
  "embeds",
  "poll",
  "cta",
  "ai_copilot",
  "horizontal_rule",
  "code_block",
  "mention",
  "entities",
];

export const restrictedSlashMenuCategories = ["Upload", "Embed"];

export const restrictedSlashMenuCommands = [
  "image",
  "giphy",
  "audio",
  "video",
  "pdf",
  "file",
  "poll",
  "code",
];

/**
 * Combined editor restrictions object for use with spread operator
 */
export const editorRestrictions = {
  disabledExtensions: restrictedEditorExtensions,
  disabledSlashMenuCategories: restrictedSlashMenuCategories,
  disabledSlashMenuCommands: restrictedSlashMenuCommands,
};
